export default "__VITE_ASSET__QMT9Vrqd__"